export const MODEL_ROUTE = '/physicians';
